const localization = {
  panelCollapsed: (label: string) => `${label} collapsed`,
}

export const resizableHandleLocalization = {
  resizePanels: 'Resize panels',
}

export default localization
